import React from 'react';
import util from "../../../../../../utils/es5Utils";
import _ from "underscore";

const Repeater  = function(props){
    const widgets = util.widgetsOfType(props.context, "repeater");
    const newProps = Object.assign({}, props, { widgets });
    const childBlocks = _.values(props.blocks).map((Component, id) => <Component.component { ...newProps } key={id}/>);
    
    if (widgets.length > 0 && childBlocks.length > 0) {
        return (
            <category name='Repeater' id='repeater' iconclass='category with-icon-paths snap-icon-repeater_dual'>
                <label text={"Repeater"}/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Repeater;
